import * as React from 'react';
import 'isomorphic-fetch';
export class ImageEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, image: null, saveError: "", file: null };
        this.refresh();
    }
    refresh() {
        this.setState({
            loading: true,
            image: null,
            saveError: "",
            file: null
        });
        fetch('Data/GetImageInfo/' + this.props.imageId, { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            this.setState({ loading: false, image: data, saveError: "", file: null });
        });
    }
    render() {
        let result = React.createElement("div", null);
        if (this.state.loading) {
            result = React.createElement("div", null, "Fetching image info...");
        }
        else {
            let gotAnyError = React.createElement("span", null);
            if (this.state.saveError != null && this.state.saveError != "") {
                gotAnyError = React.createElement("span", null,
                    "Update error:",
                    this.state.saveError,
                    React.createElement("br", null));
            }
            result = React.createElement("div", null,
                "Name:",
                this.state.image.name,
                React.createElement("br", null),
                "Data Guid:",
                this.state.image.dataGuid,
                React.createElement("br", null),
                "Tag:",
                this.state.image.tag,
                React.createElement("br", null),
                React.createElement("br", null),
                "New Image File:",
                React.createElement("br", null),
                gotAnyError,
                React.createElement("input", { type: "file", accept: ".jpg, .jpeg, .png", className: "form-control", onChange: (e) => { this.onImageChanged(e.target.files[0]); } }),
                React.createElement("button", { className: "btn btn-primary", onClick: () => this.onSaveChanges() }, "Update Image"),
                React.createElement("br", null),
                "Visual:",
                React.createElement("br", null),
                React.createElement("img", { src: "Data/GetImage/" + this.props.imageId }));
        }
        return result;
    }
    onImageChanged(file) {
        this.setState({
            loading: this.state.loading,
            image: this.state.image,
            saveError: this.state.saveError,
            file: file
        });
    }
    onSaveChanges() {
        this.setState({ loading: true, image: this.state.image, saveError: "", file: this.state.file });
        var formData = new FormData();
        formData.append("file", this.state.file);
        fetch('Data/UpdateImageData/' + this.props.imageId, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
            },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
            this.setState({
                loading: false,
                image: this.state.image,
                saveError: result.errorCode,
                file: null
            });
        });
    }
}
//# sourceMappingURL=ImageEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/ImageEditor.js
// module id = 94
// module chunks = 0